module.exports = __webpack_public_path__ + "img/passo1.d0698c6a.png";